/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';

import {
  MdShoppingCart,
  MdClose,
  MdChevronLeft,
  MdChevronRight,
  // MdWhatsapp,
} from 'react-icons/md';
import * as Yup from 'yup';
import PropTypes from 'prop-types';

import { AppError } from '../../../errors/AppError';

import { Form, Row, Column } from '../../Form';
import SelectInput from '../../Form/Input/Select';
import Input from '../../Form/Input';

import { adicionaCarrinhoRequest } from '../../../store/modules/cart/actions';

import { Content, WrapperPopup, WrapperItem } from './styles';
import {
  // criaItemOSSisma,
  limitaQtdMax,
  limitaQtdMin,
  limiteItemQtdZero,
  qtdItemInic0,
} from '../../../lib/paramUtils';

function MobileItemCart({ item, onClose }) {
  const formRef = useRef();

  const dispatch = useDispatch();

  useEffect(() => {
    const { quantidade } = item || { quantidade: 0 };

    /** insere a quantidade indicada do item */
    formRef.current.setFieldValue('quantidade', quantidade);
  }, [item]);

  // const handleConfirmar = useCallback(
  //   async (data) => {
  //     try {
  //       /** validação do preenchimento do campo código ERP  */
  //       if (item.materialEmpresa.length > 0) {
  //         const schema = Yup.object().shape({
  //           materialEmpresa: Yup.string().required('Selecione um material'),
  //         });

  //         await schema.validate(data, { abortEarly: false });
  //       }

  //       /** adiciona no carrinho */
  //       const {
  //         idCatalogo,
  //         idPagina,
  //         idItem,
  //         idMaterial,
  //         imagemCatalogo,
  //       } = item;
  //       const { quantidade, materialEmpresa } = data;
  //       dispatch(
  //         adicionaCarrinhoRequest(
  //           idCatalogo,
  //           idPagina,
  //           idItem,
  //           idMaterial,
  //           Number(quantidade),
  //           materialEmpresa,
  //           imagemCatalogo
  //         )
  //       );

  //       /** executa método para fechar o formulário */
  //       onClose(data);
  //     } catch (err) {
  //       AppError(err, formRef);
  //     }
  //   },
  //   [item, dispatch, onClose]
  // );

  // const handleConfirmar = useCallback(
  //   async (data) => {
  //     try {
  //       /** validação do preenchimento do campo código ERP  */
  //       if (item.materialEmpresa.length > 0) {
  //         const schema = Yup.object().shape({
  //           materialEmpresa: Yup.string().required('Selecione um material'),
  //         });

  //         await schema.validate(data, { abortEarly: false });
  //       }

  //       /** adiciona no carrinho */
  //       const {
  //         idCatalogo,
  //         idPagina,
  //         idItem,
  //         idMaterial,
  //         imagemCatalogo,
  //       } = item;
  //       const { quantidade, materialEmpresa, itemOS } = data;

  //       // console.log(quantidade);
  //       // console.log(item.quantidade);
  //       // console.log(limitaQtdMax());
  //       // console.log(limitaQtdMin());
  //       // console.log(limiteItemQtdZero());

  //       if (limiteItemQtdZero().active) {
  //         if (
  //           Number(item.quantidade) === 0 &&
  //           Number(quantidade) > Number(limiteItemQtdZero().value)
  //         ) {
  //           window.confirm(
  //             `A quantidade não pode ser maior que ${
  //               limiteItemQtdZero().value
  //             } para itens que o catálogo indique a quantidade 0`
  //           );
  //           return;
  //         }
  //       }

  //       if (limitaQtdMax().active && !limitaQtdMin().active) {
  //         if (Number(limitaQtdMax().value) === 1) {
  //           if (Number(quantidade) > Number(item.quantidade)) {
  //             window.confirm(
  //               'Não é permitido adicionar uma quantidade maior do que a estabelecida pelo catálogo'
  //             );
  //             return;
  //           }
  //         }
  //         if (Number(limitaQtdMax().value) === 2) {
  //           if (Number(quantidade) > Number(item.quantidade)) {
  //             window.confirm(
  //               'Uma quantidade maior do que a estabelecida pelo catálogo esta sendo adicionada'
  //             );
  //           }
  //         }
  //       }

  //       if (limitaQtdMin().active && !limitaQtdMax().active) {
  //         if (Number(limitaQtdMin().value) === 1) {
  //           if (Number(quantidade) < Number(item.quantidade)) {
  //             window.confirm(
  //               'Não é permitido adicionar uma quantidade menor do que a estabelecida pelo catálogo'
  //             );
  //             return;
  //           }
  //         }
  //         if (Number(limitaQtdMin().value) === 2) {
  //           if (Number(quantidade) < Number(item.quantidade)) {
  //             window.confirm(
  //               'Uma quantidade menor do que a estabelecida pelo catálogo esta sendo adicionada'
  //             );
  //           }
  //         }
  //       }

  //       if (limitaQtdMin().active && limitaQtdMax().active) {
  //         if (
  //           Number(limitaQtdMax().value) === 1 &&
  //           Number(limitaQtdMin().value) === 1
  //         ) {
  //           if (Number(quantidade) !== Number(item.quantidade)) {
  //             window.confirm(
  //               'Somente a quantidade exata estabelecida pelo catálogo pode ser adicionada'
  //             );
  //             return;
  //           }
  //         }
  //         if (
  //           Number(limitaQtdMax().value) === 2 &&
  //           Number(limitaQtdMin().value) === 2
  //         ) {
  //           if (Number(quantidade) !== Number(item.quantidade)) {
  //             window.confirm(
  //               'A quantidade esta diferente da estabelecida no catálogo'
  //             );
  //             return;
  //           }
  //         }
  //       }

  //       // const objAgenteCausa = agenteCausa.pop();
  //       // const objMotivoFalha = motivoFalha.pop();
  //       // const objSecaoTrab = secaoTrab.pop();

  //       // const { codiAgente } = objAgenteCausa;
  //       // const { codiMofa } = objMotivoFalha;
  //       // const { codiSetr } = objSecaoTrab;

  //       // const codiSist = sistemaSelecionado ? sistemaSelecionado.value : 0;
  //       // const codiLoca = localSelecionado ? localSelecionado.value : 0;

  //       dispatch(
  //         adicionaCarrinhoRequest(
  //           idCatalogo,
  //           idPagina,
  //           idItem,
  //           idMaterial,
  //           Number(quantidade),
  //           materialEmpresa,
  //           imagemCatalogo,
  //           itemOS
  //           // criaItemOSSisma() ? codiAgente : 0,
  //           // criaItemOSSisma() ? codiMofa : 0,
  //           // criaItemOSSisma() ? codiSetr : 0,
  //           // criaItemOSSisma() ? codiSist : 0,
  //           // criaItemOSSisma() ? codiLoca : 0
  //         )
  //       );

  //       /** executa método para fechar o formulário */
  //       onClose(data);
  //     } catch (err) {
  //       AppError(err, formRef);
  //     }
  //   },
  //   [
  //     item,
  //     dispatch,
  //     onClose,
  //     // sistemaSelecionado,
  //     // localSelecionado,
  //     // agenteCausa,
  //     // motivoFalha,
  //     // secaoTrab,
  //   ]
  // );

  // const handleConfirmar = useCallback(
  //   async (data) => {
  //     try {
  //       /** validação do preenchimento do campo código ERP  */
  //       if (item.materialEmpresa.length > 0) {
  //         const schema = Yup.object().shape({
  //           materialEmpresa: Yup.string().required('Selecione um material'),
  //         });

  //         await schema.validate(data, { abortEarly: false });
  //       }

  //       /** adiciona no carrinho */
  //       const {
  //         idCatalogo,
  //         idPagina,
  //         idItem,
  //         idMaterial,
  //         imagemCatalogo,
  //       } = item;

  //       const { quantidade, materialEmpresa, itemOS } = data;

  //       const qtdCatalogo = Number(item.quantidade);
  //       const qtdInformada = Number(quantidade);

  //       const regraQtdMax = limitaQtdMax();
  //       const regraQtdMin = limitaQtdMin();
  //       const regraQtdZero = limiteItemQtdZero();

  //       /**
  //        * REGRA ESPECIAL:
  //        * Quando o item do catálogo vier com quantidade 0,
  //        * aplica apenas a regra de limiteItemQtdZero e
  //        * não aplica as regras de min/max exato do catálogo.
  //        */
  //       const isItemQtdZeroComLimite = regraQtdZero.active && qtdCatalogo === 0;

  //       if (isItemQtdZeroComLimite) {
  //         if (qtdInformada < 1) {
  //           window.alert('A quantidade deve ser maior que 0');
  //           return;
  //         }

  //         if (qtdInformada > Number(regraQtdZero.value)) {
  //           window.alert(
  //             `A quantidade não pode ser maior que ${regraQtdZero.value} para itens que o catálogo indique a quantidade 0`
  //           );
  //           return;
  //         }
  //       } else {
  //         if (
  //           regraQtdMax.active &&
  //           !regraQtdMin.active &&
  //           !isItemQtdZeroComLimite
  //         ) {
  //           if (Number(regraQtdMax.value) === 1) {
  //             if (qtdInformada > qtdCatalogo) {
  //               window.alert(
  //                 'Não é permitido adicionar uma quantidade maior do que a estabelecida pelo catálogo'
  //               );
  //               return;
  //             }
  //           }

  //           if (Number(regraQtdMax.value) === 2) {
  //             if (qtdInformada > qtdCatalogo) {
  //               window.alert(
  //                 'Uma quantidade maior do que a estabelecida pelo catálogo esta sendo adicionada'
  //               );
  //             }
  //           }
  //         }

  //         if (
  //           regraQtdMin.active &&
  //           !regraQtdMax.active &&
  //           !isItemQtdZeroComLimite
  //         ) {
  //           if (Number(regraQtdMin.value) === 1) {
  //             if (qtdInformada < qtdCatalogo) {
  //               window.alert(
  //                 'Não é permitido adicionar uma quantidade menor do que a estabelecida pelo catálogo'
  //               );
  //               return;
  //             }
  //           }

  //           if (Number(regraQtdMin.value) === 2) {
  //             if (qtdInformada < qtdCatalogo) {
  //               window.alert(
  //                 'Uma quantidade menor do que a estabelecida pelo catálogo esta sendo adicionada'
  //               );
  //             }
  //           }
  //         }

  //         if (
  //           regraQtdMin.active &&
  //           regraQtdMax.active &&
  //           !isItemQtdZeroComLimite
  //         ) {
  //           if (
  //             Number(regraQtdMax.value) === 1 &&
  //             Number(regraQtdMin.value) === 1
  //           ) {
  //             if (qtdInformada !== qtdCatalogo) {
  //               window.alert(
  //                 'Somente a quantidade exata estabelecida pelo catálogo pode ser adicionada'
  //               );
  //               return;
  //             }
  //           }

  //           if (
  //             Number(regraQtdMax.value) === 2 &&
  //             Number(regraQtdMin.value) === 2
  //           ) {
  //             if (qtdInformada !== qtdCatalogo) {
  //               window.alert(
  //                 'A quantidade esta diferente da estabelecida no catálogo'
  //               );
  //             }
  //           }
  //         }
  //       }

  //       dispatch(
  //         adicionaCarrinhoRequest(
  //           idCatalogo,
  //           idPagina,
  //           idItem,
  //           idMaterial,
  //           Number(quantidade),
  //           materialEmpresa,
  //           imagemCatalogo,
  //           itemOS
  //         )
  //       );

  //       /** executa método para fechar o formulário */
  //       onClose(data);
  //     } catch (err) {
  //       AppError(err, formRef);
  //     }
  //   },
  //   [item, dispatch, onClose]
  // );

  // const handleConfirmar = useCallback(
  //   async (data) => {
  //     try {
  //       /** validação do preenchimento do campo código ERP  */
  //       if (item.materialEmpresa.length > 0) {
  //         const schema = Yup.object().shape({
  //           materialEmpresa: Yup.string().required('Selecione um material'),
  //         });

  //         await schema.validate(data, { abortEarly: false });
  //       }

  //       /** adiciona no carrinho */
  //       const {
  //         idCatalogo,
  //         idPagina,
  //         idItem,
  //         idMaterial,
  //         imagemCatalogo,
  //       } = item;
  //       const { quantidade, materialEmpresa, itemOS } = data;

  //       const qtdCatalogo = Number(item.quantidade);
  //       const qtdInformada = Number(quantidade);

  //       const regraQtdMax = limitaQtdMax();
  //       const regraQtdMin = limitaQtdMin();
  //       const regraQtdZero = limiteItemQtdZero();

  //       // console.log(quantidade);
  //       // console.log(item.quantidade);
  //       // console.log(limitaQtdMax());
  //       // console.log(limitaQtdMin());
  //       // console.log(limiteItemQtdZero());

  //       /**
  //        * Regra especial para itens que o catálogo indica quantidade 0.
  //        * Quando essa regra estiver ativa, ela terá prioridade e
  //        * não deixará cair nas validações de quantidade exata do catálogo.
  //        */
  //       if (regraQtdZero.active && qtdCatalogo === 0) {
  //         if (qtdInformada < 1) {
  //           window.alert('A quantidade deve ser maior que 0');
  //           return;
  //         }

  //         if (qtdInformada > Number(regraQtdZero.value)) {
  //           window.alert(
  //             `A quantidade não pode ser maior que ${regraQtdZero.value} para itens que o catálogo indique a quantidade 0`
  //           );
  //           return;
  //         }
  //       } else {
  //         if (regraQtdMax.active && !regraQtdMin.active) {
  //           if (Number(regraQtdMax.value) === 1) {
  //             if (qtdInformada > qtdCatalogo) {
  //               window.alert(
  //                 'Não é permitido adicionar uma quantidade maior do que a estabelecida pelo catálogo'
  //               );
  //               return;
  //             }
  //           }
  //           if (Number(regraQtdMax.value) === 2) {
  //             if (qtdInformada > qtdCatalogo) {
  //               window.alert(
  //                 'Uma quantidade maior do que a estabelecida pelo catálogo esta sendo adicionada'
  //               );
  //             }
  //           }
  //         }

  //         if (regraQtdMin.active && !regraQtdMax.active) {
  //           if (Number(regraQtdMin.value) === 1) {
  //             if (qtdInformada < qtdCatalogo) {
  //               window.alert(
  //                 'Não é permitido adicionar uma quantidade menor do que a estabelecida pelo catálogo'
  //               );
  //               return;
  //             }
  //           }
  //           if (Number(regraQtdMin.value) === 2) {
  //             if (qtdInformada < qtdCatalogo) {
  //               window.alert(
  //                 'Uma quantidade menor do que a estabelecida pelo catálogo esta sendo adicionada'
  //               );
  //             }
  //           }
  //         }

  //         if (regraQtdMin.active && regraQtdMax.active) {
  //           if (
  //             Number(regraQtdMax.value) === 1 &&
  //             Number(regraQtdMin.value) === 1
  //           ) {
  //             if (qtdInformada !== qtdCatalogo) {
  //               window.alert(
  //                 'Somente a quantidade exata estabelecida pelo catálogo pode ser adicionada'
  //               );
  //               return;
  //             }
  //           }
  //           if (
  //             Number(regraQtdMax.value) === 2 &&
  //             Number(regraQtdMin.value) === 2
  //           ) {
  //             if (qtdInformada !== qtdCatalogo) {
  //               window.alert(
  //                 'A quantidade esta diferente da estabelecida no catálogo'
  //               );
  //             }
  //           }
  //         }
  //       }

  //       // const objAgenteCausa = agenteCausa.pop();
  //       // const objMotivoFalha = motivoFalha.pop();
  //       // const objSecaoTrab = secaoTrab.pop();

  //       // const { codiAgente } = objAgenteCausa;
  //       // const { codiMofa } = objMotivoFalha;
  //       // const { codiSetr } = objSecaoTrab;

  //       // const codiSist = sistemaSelecionado ? sistemaSelecionado.value : 0;
  //       // const codiLoca = localSelecionado ? localSelecionado.value : 0;

  //       dispatch(
  //         adicionaCarrinhoRequest(
  //           idCatalogo,
  //           idPagina,
  //           idItem,
  //           idMaterial,
  //           Number(quantidade),
  //           materialEmpresa,
  //           imagemCatalogo,
  //           itemOS
  //           // criaItemOSSisma() ? codiAgente : 0,
  //           // criaItemOSSisma() ? codiMofa : 0,
  //           // criaItemOSSisma() ? codiSetr : 0,
  //           // criaItemOSSisma() ? codiSist : 0,
  //           // criaItemOSSisma() ? codiLoca : 0
  //         )
  //       );

  //       /** executa método para fechar o formulário */
  //       onClose(data);
  //     } catch (err) {
  //       AppError(err, formRef);
  //     }
  //   },
  //   [
  //     item,
  //     dispatch,
  //     onClose,
  //     // sistemaSelecionado,
  //     // localSelecionado,
  //     // agenteCausa,
  //     // motivoFalha,
  //     // secaoTrab,
  //   ]
  // );

  const handleConfirmar = useCallback(
    async (data) => {
      try {
        if (item.materialEmpresa.length > 0) {
          const schema = Yup.object().shape({
            materialEmpresa: Yup.string().required('Selecione um material'),
          });

          await schema.validate(data, { abortEarly: false });
        }

        const {
          idCatalogo,
          idPagina,
          idItem,
          idMaterial,
          imagemCatalogo,
        } = item;

        const { quantidade, materialEmpresa, itemOS } = data;

        const normalizaNumero = (valor) => {
          if (valor === null || valor === undefined) return 0;
          return Number(String(valor).replace(',', '.').trim());
        };

        const qtdCatalogo = normalizaNumero(item.quantidade);
        const qtdInformada = normalizaNumero(quantidade);

        const regraQtdMax = limitaQtdMax();
        const regraQtdMin = limitaQtdMin();
        const regraQtdZero = limiteItemQtdZero();
        const itemIniciaComZero = qtdItemInic0();

        // caso especial: item do catálogo com quantidade 0
        const isItemQtdZeroComLimite =
          itemIniciaComZero && regraQtdZero.active && qtdCatalogo === 0;

        // console.log({
        //   itemQuantidade: item.quantidade,
        //   qtdCatalogo,
        //   qtdInformada,
        //   regraQtdZero,
        //   regraQtdMax,
        //   regraQtdMin,
        //   itemIniciaComZero: qtdItemInic0(),
        //   isItemQtdZeroComLimite,
        // });

        if (isItemQtdZeroComLimite) {
          if (qtdInformada < 1) {
            window.alert('A quantidade deve ser maior que 0');
            return;
          }

          if (qtdInformada > regraQtdZero.value) {
            window.alert(
              `A quantidade não pode ser maior que ${regraQtdZero.value} para itens que o catálogo indique a quantidade 0`
            );
            return;
          }

          // passou na regra especial, adiciona direto ao carrinho
          dispatch(
            adicionaCarrinhoRequest(
              idCatalogo,
              idPagina,
              idItem,
              idMaterial,
              qtdInformada,
              materialEmpresa,
              imagemCatalogo,
              itemOS
            )
          );

          onClose(data);
          return;
        }

        // regras normais de min/max
        if (regraQtdMax.active && !regraQtdMin.active) {
          if (Number(regraQtdMax.value) === 1) {
            if (qtdInformada > qtdCatalogo) {
              window.alert(
                'Não é permitido adicionar uma quantidade maior do que a estabelecida pelo catálogo'
              );
              return;
            }
          }

          if (Number(regraQtdMax.value) === 2) {
            if (qtdInformada > qtdCatalogo) {
              window.alert(
                'Uma quantidade maior do que a estabelecida pelo catálogo esta sendo adicionada'
              );
            }
          }
        }

        if (regraQtdMin.active && !regraQtdMax.active) {
          if (Number(regraQtdMin.value) === 1) {
            if (qtdInformada < qtdCatalogo) {
              window.alert(
                'Não é permitido adicionar uma quantidade menor do que a estabelecida pelo catálogo'
              );
              return;
            }
          }

          if (Number(regraQtdMin.value) === 2) {
            if (qtdInformada < qtdCatalogo) {
              window.alert(
                'Uma quantidade menor do que a estabelecida pelo catálogo esta sendo adicionada'
              );
            }
          }
        }

        if (regraQtdMin.active && regraQtdMax.active) {
          if (
            Number(regraQtdMax.value) === 1 &&
            Number(regraQtdMin.value) === 1
          ) {
            if (qtdInformada !== qtdCatalogo) {
              window.alert(
                'Somente a quantidade exata estabelecida pelo catálogo pode ser adicionada'
              );
              return;
            }
          }

          if (
            Number(regraQtdMax.value) === 2 &&
            Number(regraQtdMin.value) === 2
          ) {
            if (qtdInformada !== qtdCatalogo) {
              window.alert(
                'A quantidade esta diferente da estabelecida no catálogo'
              );
            }
          }
        }

        dispatch(
          adicionaCarrinhoRequest(
            idCatalogo,
            idPagina,
            idItem,
            idMaterial,
            qtdInformada,
            materialEmpresa,
            imagemCatalogo,
            itemOS
          )
        );

        onClose(data);
      } catch (err) {
        AppError(err, formRef);
      }
    },
    [item, dispatch, onClose]
  );

  const handleAdicionar = useCallback(() => {
    /** pega informações do campo */
    const quantidade = Number(formRef.current.getFieldValue('quantidade'));

    formRef.current.setFieldValue('quantidade', quantidade + 1);
  }, []);

  const handleRemover = useCallback(() => {
    /** pega informações do campo */
    const quantidade = Number(formRef.current.getFieldValue('quantidade'));

    if (quantidade > 1) {
      formRef.current.setFieldValue('quantidade', quantidade - 1);
    }
  }, []);

  // const handleWhatsApp = useCallback(async () => {
  //   const {
  //     idCatalogo,
  //     idPagina,
  //     idItem,
  //     idMaterial,
  //     fabricante,
  //     descricao,
  //   } = item;
  //   const quantidade = Number(formRef.current.getFieldValue('quantidade'));
  //   const materialEmpresa = String(
  //     formRef.current.getFieldValue('materialEmpresa')
  //   );
  //   // const { quantidade, materialEmpresa } = data;

  //   // console.log(data);
  //   console.log(item);
  //   console.log(materialEmpresa);

  //   console.log('whatsapp');
  //   console.log('https://api.whatsapp.com/send?phone=NUMERO&text=MENSAGEM');

  //   // Pegar o numero do telfone do usuario logado
  //   const numeroTelefone = '5519989479385';

  //   const fmtData = `
  //     *Catálogo:* ${idCatalogo},
  //     *Pagina:* ${idPagina},
  //     *Fabricante:* ${fabricante.descricao},
  //     *Item:* ${idItem},
  //     *Material:* ${idMaterial},
  //     *Descrição Peça:* ${descricao},
  //     *Quantidade:* ${quantidade}
  //   `;

  //   // const fmtData2 = `
  //   //   *Catálogo:* ${firstItem.catalogo},
  //   //   *Modelo:* ${firstItem.modelo},
  //   //   *Versão:* ${firstItem.versao},
  //   //   *Fabricante:* ${firstItem.fabricante}
  //   // `;

  //   console.log(fmtData);

  //   const filenameTeste = 'baixados.csv';

  //   const testeLinkURL = `${process.env.REACT_APP_BASE_URL}download/csv/${filenameTeste}`;
  //   const testeLink =
  //     'https://api-cdi.assisteweb.com.br/download/csv/catalogo-eletronico-carrinho.csv';

  //   const mensagem = encodeURIComponent(
  //     `*Envio via CDI* da página do catálogo: \n ${fmtData} \n *Link de download:* ${testeLink}`
  //   );

  //   // Chamar a criação do .csv e enviar o link
  //   // const linkArquivo = await handleExportar(true);
  //   // console.log(linkArquivo);

  //   // const linkArquivo = 'https://link-para-o-arquivo.xlsx';

  //   // const urlWhatsApp = `https://api.whatsapp.com/send?&text=${mensagem}&file=${linkArquivo.href}`;
  //   const urlWhatsApp = `https://api.whatsapp.com/send?&text=${mensagem}&app_absent=0`;

  //   setTimeout(() => window.open(urlWhatsApp, '_blank'), 5000);

  //   handleConfirmar({ quantidade, materialEmpresa });

  //   // window.open(urlWhatsApp, '_blank');
  // }, []);

  return (
    <WrapperPopup>
      <WrapperItem>
        <Content>
          <Content.BtnClose type="button" onClick={() => onClose()}>
            <MdClose size={20} />
          </Content.BtnClose>

          <Content.Title>
            <strong>{item.descricao}</strong>
            <span>{item.partnumber}</span>

            {item.especTecnica && (
              <Content.Title.Espec>{item.especTecnica}</Content.Title.Espec>
            )}
          </Content.Title>
          <Content.Form>
            {item && (
              <Form id="formCart" ref={formRef} onSubmit={handleConfirmar}>
                <Column borderTop>
                  {item.materialEmpresa.length > 0 && (
                    <SelectInput
                      id="materialEmpresa"
                      name="materialEmpresa"
                      label="Código ERP"
                      isClearable
                      options={item.materialEmpresa.map((material) => ({
                        value: material.codimate,
                        label: `${material.codimate} - ${material.descricao}`,
                        color:
                          material.paralelo === '0' ? '#2c405a' : '#de3b3b',
                        fontStyle:
                          material.paralelo === '0' ? 'normal' : 'italic',
                      }))}
                      styles={{
                        option: (styles, { data }) => ({
                          ...styles,
                          color: data.color,
                          fontStyle: data.fontStyle,
                        }),
                      }}
                    />
                  )}
                  <Content.Form.Error>
                    {item.materialEmpresa.length > 0
                      ? 'Atenção: Materiais não originais estão destacados na listagem'
                      : 'Nenhum Código ERP relacionado com esse material para integração'}
                  </Content.Form.Error>
                </Column>

                <Row>
                  <Content.Form.Quantity>
                    <label htmlFor="quantidade">Quantidade</label>
                    <div>
                      <button type="button" onClick={handleRemover}>
                        <MdChevronLeft size={25} />
                      </button>
                      <Input
                        id="quantidade"
                        name="quantidade"
                        flexDirection="row"
                        // disabled
                        type="number"
                        min="1"
                        max="9999999.9999"
                        width={80}
                      />
                      <button type="button" onClick={handleAdicionar}>
                        <MdChevronRight size={25} />
                      </button>
                    </div>
                  </Content.Form.Quantity>
                </Row>
              </Form>
            )}

            <Content.BtnAddCart type="submit" form="formCart">
              <MdShoppingCart size={20} /> Adicionar ao carrinho
            </Content.BtnAddCart>
            {/* <Content.BtnWhatsApp type="button" onClick={handleWhatsApp}>
              <MdWhatsapp size={25} /> Enviar WhatsApp
            </Content.BtnWhatsApp> */}
          </Content.Form>
        </Content>
      </WrapperItem>
    </WrapperPopup>
  );
}

MobileItemCart.propTypes = {
  item: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
};

export { MobileItemCart };
